module.exports = __webpack_public_path__ + "static/media/8.d86b2a87.wav";